
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import UsersListView from "./users-list.html";
import UsersEditView from "./users-edit.html";

angular.module("users", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('users', {
                url: "/users",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('users.list', {
                url: "/list",
                controller: "UsersListCtrl",
                template: UsersListView,
                data: {pageTitle: "Usuarios"},
                requiredPermission: ["USERS_READ"]
            })
            .state('users.edit', {
                url: "/edit/:id",
                controller: "UsersEditCtrl",
                template: UsersEditView,
                data: { pageTitle: "Usuario" } ,
                requiredPermission: ["USERS_READ"]
            })
            .state('users.profile', {
                url: "/:id",
                controller: "UsersEditCtrl",
                template: UsersEditView,
                params: {
                    'id': 'profile'
                },
                data: { pageTitle: "Usuario" }
            })
        ;
    }])
;